import { FORM_SCHEDULE_STATUS, FORM_TYPES } from "@/components/stores/constants/constants.stores";
import { SCHEDULES_STORE_NAMES } from "@/db/constants";
import { generateIdDateNow, getDateNow } from "@/utils/basicUtils";
import { isWeb } from "@/utils/platformUtils";
import { getDb } from "../adapter";


export interface Campaing {
    _id:                    string;
    name:                   string;
    code:                   string;
    prefix:                 string;
    image:                  string;
    date_init:              Date;
    date_finish:            Date;
    date_moderation_init:   Date;
    date_moderation_finish: Date;
    moderation:             boolean;
    steps:                  Step[];
    total_progres:          number;
    values:                 Value[];
    pos:                    any[];
    schedule_free:          boolean;
    schedules:              Schedule[];
    status:                 number;
    _v:                     number;
}

export interface Schedule {
    _id:                        string;
    date_finish:                Date;
    date_init:                  Date;
    progress_diary:             boolean;
    activities:                 any[];
    vacation:                   boolean;
    others_activities:          any[];
    additional:                 Additional;
    form_init:                  string;
    form_finish:                string;
    activities_advances:        null;
    others_activities_advances: null;
    forms_additionals:          any[];
    forms_incidence:            null;
    reports:                    Additional;
    data_version:               number;
    history_forms:              any[];
}

export interface Additional {
}

export interface Step {
    name:            string;
    code:            string;
    prefix:          string;
    image:           string;
    date_init:       Date;
    date_finish:     Date;
    type:            string;
    forms:           Form[];
    checkins?:       number | null;
    forms_objetive?: FormsObjetive[];
}

export interface Form {
    _id:    string;
    status: number;
}

export interface FormsObjetive {
    form_id: number;
    count:   number;
}

export interface Value {
    label:     string;
    value:     number;
    color_hex: string;
}

interface SaveFormAnswersResult {
  end: 'saveFormAnswers';
  result: any | null;
  message: string;
}

// TIP: tipá mejor este form según tu modelo real
type SaveFormInput = any;

export async function saveFormAnswers(form: SaveFormInput): Promise<SaveFormAnswersResult> {

    const { schedule_id, form_id, store_id, repeat, questions, progress, totalScore, answers = '[]', status, type_form, checkin_id } = form


    // 🚨 DEBUG: Log para detectar llamadas problemáticas
    if (answers === '[]' && status && parseInt(status) === 5) {
        // console.log('🚨 ALERT: saveFormAnswers called with empty answers and completed status')
        // console.log('📋 Form details:', { form_id, schedule_id, store_id, status, answersLength: JSON.parse(answers).length })
    }

    // Si no hay preguntas y no es redirect, no hacemos nada
    if (
        JSON.parse(questions).length === 0 &&
        type_form?.type !== FORM_TYPES.FORM_REDIRECT
    ) {
        return {
        end: 'saveFormAnswers',
        result: null,
        message: 'Form sin preguntas, no se crea registro',
        };
    }

    const { cantQuestionPonderar, scoreTotalQuestionsPonderar } = getCantQuestionPonderar(questions)

    const date_init = getDateNow()
    const date_finish = ''
    const generateIdDate = generateIdDateNow()

    if (isWeb()) {
        // TODO: implementar versión web (IndexedDB, etc.)
        // Por ahora puedes lanzar error o devolver un mensaje
        return {
            end: 'saveFormAnswers',
            result: null,
            message: 'saveFormAnswers web no implementado aún',
        }
    }

    const db = await getDb();

    const response = await db.transaction<SaveFormAnswersResult>(async (txn) => {
        // 1) Primero veo si ya existe un registro compatible

        let selectSql = ''
        let selectParams: any[] = []

        if (store_id) {
            if (repeat === 1) {
                selectSql = `
                    SELECT *
                    FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                    WHERE schedule_id = ?
                        AND form_id = ?
                        AND store_id = ?
                        AND status NOT IN (?, ?);
                `
                selectParams = [schedule_id, form_id, store_id, FORM_SCHEDULE_STATUS.COMPLETED, FORM_SCHEDULE_STATUS.PENDING_CONNECTION]
            } else {
                selectSql = `
                    SELECT *
                    FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                    WHERE schedule_id = ?
                        AND form_id = ?
                        AND store_id = ?
                        AND day_unique_id = ?;
                `
                selectParams = [schedule_id, form_id, store_id, generateIdDate]
            }
        } else {
            selectSql = `
                SELECT *
                FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                WHERE schedule_id = ?
                AND form_id = ?
                AND day_unique_id = ?
                AND status NOT IN (?, ?);
            `
            selectParams = [schedule_id, form_id, generateIdDate, FORM_SCHEDULE_STATUS.COMPLETED, FORM_SCHEDULE_STATUS.PENDING_CONNECTION]
        }

        const existingRows = await txn.getAll<any>({
            sql: selectSql,
            params: selectParams,
        })

        console.log('1existingRows found in saveFormAnswers:', existingRows.length)

        const isExists = validateDateRegister(existingRows)

        console.log('2isExists in saveFormAnswers:', isExists)

        // 2) Si NO existe → inserto registro nuevo

        if (!isExists) {
            let insertSql = ''
            let insertParams: any[] = []

            console.log('🚨 Inserting new form answers record store_id => ', store_id)
            if (store_id) {
                insertSql = `
                    INSERT INTO ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} (
                        repeat,
                        date_init,
                        date_finish,
                        schedule_id,
                        form_id,
                        store_id,
                        status,
                        answers,
                        questions,
                        progress,
                        totalScore,
                        scoreObtainedFloat,
                        cant_questions_yes_na,
                        progress_questions_yes_na,
                        scoreTotalQuestionsPonderarFloat,
                        name_form,
                        heladera,
                        create_refrigerator,
                        type_form,
                        form_id_father,
                        checkout,
                        day_unique_id,
                        checkin_id
                    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);
                `

                insertParams = [
                    repeat,
                    date_init,
                    date_finish,
                    schedule_id,
                    form_id,
                    store_id,
                    status,
                    answers,
                    questions,
                    progress,
                    totalScore,
                    form.scoreObtained,
                    cantQuestionPonderar,
                    form.progress_questions_yes_na,
                    scoreTotalQuestionsPonderar,
                    form.name_form,
                    form.heladera,
                    form.create_refrigerator,
                    JSON.stringify(form.type_form),
                    form.form_id_father,
                    form.checkout,
                    generateIdDate,
                    checkin_id,
                ]
            } else {
                insertSql = `
                    INSERT INTO ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} (
                        repeat,
                        date_init,
                        schedule_id,
                        form_id,
                        store_id,
                        status,
                        answers,
                        questions,
                        progress,
                        totalScore,
                        scoreObtainedFloat,
                        cant_questions_yes_na,
                        progress_questions_yes_na,
                        scoreTotalQuestionsPonderarFloat,
                        name_form,
                        heladera,
                        create_refrigerator,
                        type_form,
                        form_id_father,
                        day_unique_id,
                        checkin_id
                    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);
                `

                insertParams = [
                    repeat,
                    date_init,
                    schedule_id,
                    form_id,
                    '',
                    status,
                    answers,
                    questions,
                    progress,
                    totalScore,
                    0,
                    cantQuestionPonderar,
                    0,
                    scoreTotalQuestionsPonderar,
                    form.name_form,
                    form.heladera,
                    form.create_refrigerator,
                    JSON.stringify(form.type_form),
                    form.form_id_father,
                    generateIdDate,
                    checkin_id,
                ]
            }


            console.log('insertParams saveFormAnswers:')
            // insertParams.forEach((v, i) => {
            //     console.log(i, '=>', v, 'typeof:', typeof v)
            // })
            // console.log('🚨 insertParams =>', insertParams)
            // console.log('🚨 insertSql =>', insertSql)

            await txn.run({ sql: insertSql, params: insertParams })

            console.log('🚨 Inserted new form answers record successfully')

            // Busco el registro recién creado
            let getSql = ''
            let getParams: any[] = []

            if (store_id) {
                getSql = `
                    SELECT *
                    FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                    WHERE schedule_id = ?
                        AND form_id = ?
                        AND store_id = ?
                        AND day_unique_id = ?;
                `
                getParams = [schedule_id, form_id, store_id, generateIdDate]
            } else {
                getSql = `
                    SELECT *
                    FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                    WHERE schedule_id = ?
                        AND form_id = ?
                        AND day_unique_id = ?;
                `
                getParams = [schedule_id, form_id, generateIdDate]
            }

            const createdRecord = await txn.getFirst<any>({
                sql: getSql,
                params: getParams,
            })

            console.log('🚨 Created record fetched:', createdRecord)

            if (createdRecord) {
                return {
                    end: 'saveFormAnswers',
                    result: createdRecord,
                    message: 'Agrego el registro con éxito: saveFormAnswers',
                }
            }

            return {
                end: 'saveFormAnswers',
                result: null,
                message: 'saveFormAnswers: quiero devolver el registro creado pero no se encontró..',
            }
        }

        // 3) Si YA existe → leo el registro actual y decido si updatear o no
        let getSql = ''
        let getParams: any[] = []

        if (store_id) {
            getSql = `
                SELECT *
                FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                WHERE schedule_id = ?
                AND form_id = ?
                AND store_id = ?
                AND day_unique_id = ?;
            `
            getParams = [schedule_id, form_id, store_id, generateIdDate]
        } else {
            getSql = `
                SELECT *
                FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                WHERE schedule_id = ?
                AND form_id = ?
                AND day_unique_id = ?;
            `
            getParams = [schedule_id, form_id, generateIdDate]
        }

        const existingRecord = await txn.getFirst<any>({ sql: getSql, params: getParams })

        if (!existingRecord) {
            return {
                end: 'saveFormAnswers',
                result: null,
                message: 'saveFormAnswers: quiero devolver el registro que ya existe pero no se encontró..',
            }
        }

        const existingAnswers = JSON.parse(existingRecord.answers || '[]')
        const newAnswers = JSON.parse(answers || '[]')

        const newStatus = status !== undefined && status !== null ? parseInt(status, 10) : status
        const existingStatus =
            existingRecord.status !== undefined && existingRecord.status !== null ? parseInt(existingRecord.status, 10) : existingRecord.status

        let needsUpdate = false

        // Comparar la clave moderation dentro de answers
        for (let i = 0; i < newAnswers.length; i++) {
            const newAnswer = newAnswers[i]
            const existingAnswer = existingAnswers.find((ans: any) => ans._id === newAnswer._id)
            if (existingAnswer) {
                if (JSON.stringify(existingAnswer.moderation) !== JSON.stringify(newAnswer.moderation)) {
                    needsUpdate = true
                    break
                }
            } else {
                needsUpdate = true
                break
            }
        }

        if (status && existingStatus !== newStatus) {
            needsUpdate = true
        }

        if (!needsUpdate) {
            return {
                end: 'saveFormAnswers',
                result: existingRecord,
                message: 'El registro ya existe y no se necesita actualizar',
            }
        }

        // 🚨 VALIDACIÓN: No sobrescribir respuestas existentes con array vacío
        let answersToUpdate = newAnswers
        if (newAnswers.length === 0 && existingAnswers.length > 0) {
            answersToUpdate = existingAnswers
        }

        let updateSql = `
            UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
            SET answers = ?
        `
        const updateParams: any[] = [JSON.stringify(answersToUpdate)]

        if (status) {
            updateSql += `, status = ?`
            updateParams.push(newStatus)
        }

        updateSql += ` WHERE schedule_id = ? AND form_id = ?`
        updateParams.push(schedule_id, form_id)

        if (store_id) {
            updateSql += ` AND store_id = ?`
            updateParams.push(store_id)
        }

        if (generateIdDate) {
            updateSql += ` AND day_unique_id = ?`
            updateParams.push(generateIdDate)
        }

        updateSql += `;`

        await txn.run({ sql: updateSql, params: updateParams })


        const updatedRecord = await txn.getFirst<any>({
            sql: getSql,
            params: getParams,
        })

        console.log('🚨 Updated record:', updatedRecord)

        if (!updatedRecord) {
            throw new Error('No se pudo obtener el registro actualizado')
        }

        return {
            end: 'saveFormAnswers',
            result: updatedRecord,
            message: 'Registro actualizado con éxito',
        }
    })

    return response

}

export async function testInsert() {
    const db = await getDb()
    try {
        // await db.run({
        //     sql: `
        //     INSERT INTO form_question_answers (
        //       repeat,
        //       date_init,
        //       schedule_id,
        //       form_id,
        //       store_id,
        //       status,
        //       answers,
        //       questions,
        //       progress,
        //       totalScore,
        //       scoreObtainedFloat,
        //       cant_questions_yes_na,
        //       progress_questions_yes_na,
        //       scoreTotalQuestionsPonderarFloat,
        //       name_form,
        //       heladera,
        //       create_refrigerator,
        //       type_form,
        //       form_id_father,
        //       day_unique_id,
        //       checkin_id
        //     ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);
        //   `,
        //     params: [
        //         null,
        //         '2025-12-01T14:11:19.406Z',
        //         '',
        //         '691f5d8c4b087e7c3279b464',
        //         '',
        //         0,
        //         '[]',
        //         '[{...}]', // podés reducirlo a algo corto para probar
        //         null,
        //         null,
        //         0,
        //         0,
        //         0,
        //         0,
        //         null,
        //         null,
        //         null,
        //         '{"_id":"6840a52c..."}',
        //         null,
        //         '251201',
        //         null,
        //     ],
        // })

        await db.run({
            sql: `
    INSERT INTO form_question_answers (
      repeat,
      date_init,
      schedule_id,
      form_id,
      store_id,
      status,
      answers,
      questions,
      progress,
      totalScore,
      scoreObtainedFloat,
      cant_questions_yes_na,
      progress_questions_yes_na,
      scoreTotalQuestionsPonderarFloat,
      name_form,
      heladera,
      create_refrigerator,
      type_form,
      form_id_father,
      day_unique_id,
      checkin_id
    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);
  `,
            params: [
                0, // repeat   ← antes null
                '2025-12-01T14:11:19.406Z', // date_init
                '', // schedule_id
                '691f5d8c4b087e7c3279b464', // form_id
                '', // store_id
                0, // status
                '[]', // answers
                '[{...}]', // questions
                0, // progress    ← antes null
                0, // totalScore  ← antes null
                0, // scoreObtainedFloat
                0, // cant_questions_yes_na
                0, // progress_questions_yes_na
                0, // scoreTotalQuestionsPonderarFloat
                '', // name_form   ← antes null
                0, // heladera    ← antes null
                0, // create_refrigerator ← antes null
                '{"_id":"6840a52c..."}', // type_form
                '', // form_id_father ← antes null
                '251201', // day_unique_id
                '', // checkin_id  ← antes null
            ],
        })

        console.error('Insert realizado con éxito')
    } catch (error) {
        console.error('Error en testInsert:', error)
    }

    try {
        const cols = await db.getAll({
            sql: 'PRAGMA table_info(form_question_answers);',
        })
        console.log('TABLE INFO:', cols)
    } catch (error) {
        console.error('Error obteniendo table_info:', error)
    }

    try {
        const schema = await db.getFirst({
            sql: `
    SELECT sql
    FROM sqlite_master
    WHERE type='table' AND name='form_question_answers';
    `,
        })
        console.log('SCHEMA:', schema)
    } catch (error) {
        console.error('Error obteniendo schema:', error)
    }
}


/**
 *
 * @param {*} questions
 * @returns {{cantQuestionPonderar<number> ; scoreTotalQuestionsPonderar<number>}}
 */
const getCantQuestionPonderar = (questions) => {
    const questionsTransform = JSON.parse(questions)
    const cantQuestionPonderar = questionsTransform.filter((obj) => obj.ponderar === true)
    const scoreTotalQuestionsPonderar = cantQuestionPonderar.reduce((accumulator, currentValue) => {
        const questionScore = currentValue.questionScore ?? 0
        const score = currentValue.score ?? 0
        return accumulator + questionScore + score
    }, 0)

    return {
        scoreTotalQuestionsPonderar,
        cantQuestionPonderar: cantQuestionPonderar.length,
    }
}

/**
 * @description valida si existe un registro, si existe true, sino existe false
 * @param {@} registersExistent
 * @returns
 */
const validateDateRegister = (registersExistent) => {
    let isExists = false
    if (!registersExistent || registersExistent.length === 0) {
        return isExists
    }

    const today = new Date().toISOString().split('T')[0]
    // console.log('2registersExistent => today =>', today, registersExistent)
    for (let i = 0; i < registersExistent.length; i++) {
        const row = registersExistent[i]
        if (row.date_init && row.date_init.split('T')[0] === today) {
            isExists = true
            break
        }
    }

    return isExists
}

/**
 * @description Obtiene la información de existencia en DB de una tienda
 * @param store_id ID de la tienda
 * @returns Promise con existsInDB y _id_mongoDB
 */
export async function getExistsInDB(store_id: string): Promise<{ existsInDB: number; _id_mongoDB: string | null }> {
    if (isWeb()) {
        throw new Error('getExistsInDB no está implementado para web')
    }

    const db = await getDb()

    const result = await db.getFirst<{ existsInDB: number; _id_mongoDB: string | null }>({
        sql: `SELECT existsInDB, _id_mongoDB FROM ${SCHEDULES_STORE_NAMES.STORES} WHERE _id = ?;`,
        params: [store_id],
    })

    if (!result) {
        throw new Error(`No se encontró la tienda con _id: ${store_id}`)
    }

    return {
        existsInDB: result.existsInDB,
        _id_mongoDB: result._id_mongoDB,
    }
}

/**
 * @description Inserta o actualiza una campaña en la base de datos
 * @param campaing Objeto con los datos de la campaña
 * @returns Promise<void>
 */
export async function addCampaing(campaing: Campaing): Promise<void> {
    if (isWeb()) {
        throw new Error('addCampaing no está implementado para web')
    }

    const db = await getDb()

    await db.transaction(async (txn) => {
        // 1. Preparar datos a guardar (convertir tipos para SQLite)
        const agendas_ids = campaing.schedules?.map((item) => item._id) || []
        const stepsJson = JSON.stringify(Array.isArray(campaing.steps) ? campaing.steps : [])
        const schedulesJson = JSON.stringify(agendas_ids)
        const valuesJson = JSON.stringify(campaing.values || [])
        
        // Convertir Date a string ISO
        const dateInitStr = campaing.date_init instanceof Date ? campaing.date_init.toISOString() : campaing.date_init
        const dateFinishStr = campaing.date_finish instanceof Date ? campaing.date_finish.toISOString() : campaing.date_finish
        const dateModerationInitStr = campaing.date_moderation_init instanceof Date 
            ? campaing.date_moderation_init.toISOString() 
            : campaing.date_moderation_init
        const dateModerationFinishStr = campaing.date_moderation_finish instanceof Date 
            ? campaing.date_moderation_finish.toISOString() 
            : campaing.date_moderation_finish
        
        // Convertir boolean a number (0 o 1)
        const scheduleFreeNum = campaing.schedule_free ? 1 : 0
        const moderationNum = campaing.moderation ? 1 : 0

        // 2. Verificar si existe (solo campos necesarios para validación)
        const existing = await txn.getFirst<{
            date_moderation_init: string | null
            date_moderation_finish: string | null
            moderation: number
            schedules: string
        }>({
            sql: `SELECT date_moderation_init, date_moderation_finish, moderation, schedules 
                  FROM ${SCHEDULES_STORE_NAMES.CAMPAINGS} 
                  WHERE _id = ?`,
            params: [campaing._id],
        })

        // 3. Datos comunes para INSERT y UPDATE
        const commonParams = [
            campaing.name,
            campaing.code,
            campaing.image,
            dateInitStr,
            dateFinishStr,
            stepsJson,
            campaing.total_progres,
            schedulesJson,
            valuesJson,
            scheduleFreeNum,
            dateModerationInitStr,
            dateModerationFinishStr,
            moderationNum,
        ]

        // 4. Si NO existe → INSERT
        if (!existing) {
            await txn.run({
                sql: `INSERT INTO ${SCHEDULES_STORE_NAMES.CAMPAINGS} (
                    _id, name, code, image, date_init, date_finish, steps, 
                    total_progres, schedules, camp_values, schedule_free,
                    date_moderation_init, date_moderation_finish, moderation
                ) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?);`,
                params: [campaing._id, ...commonParams],
            })

            console.log('🚀 Campaña insertada:', campaing._id)
            return { action: 'inserted', _id: campaing._id }
        }

        // 5. Si existe → validar cambios (incluyendo schedules)
        const needsUpdate =
            existing.date_moderation_init !== dateModerationInitStr ||
            existing.date_moderation_finish !== dateModerationFinishStr ||
            existing.moderation !== moderationNum ||
            existing.schedules !== schedulesJson  // ✅ Nuevo: detecta cambios en agendas

        if (!needsUpdate) {
            console.log('🚀 Campaña sin cambios:', campaing._id)
            return { action: 'skipped', _id: campaing._id }
        }

        // 6. Actualizar
        await txn.run({
            sql: `UPDATE ${SCHEDULES_STORE_NAMES.CAMPAINGS} SET 
                name = ?, code = ?, image = ?, date_init = ?, date_finish = ?, 
                steps = ?, total_progres = ?, schedules = ?, camp_values = ?, 
                schedule_free = ?, date_moderation_init = ?, date_moderation_finish = ?, 
                moderation = ?
                WHERE _id = ?`,
            params: [...commonParams, campaing._id],
        })

        console.log('🚀 Campaña actualizada:', campaing._id)
        return { action: 'updated', _id: campaing._id }
    })
}

/**
 * @description Guarda formularios en lotes optimizados (con INSERT OR REPLACE para upsert)
 * @param forms Array de formularios a guardar
 * @param wise Indica si es wise (default false)
 * @param heladera Indica si tiene heladera (default false)
 * @param create_refrigerator Indica si crea refrigerador (default false)
 * @param form_id_father ID del formulario padre (default '')
 * @param batchSize Tamaño inicial del lote (default 50, reducido para evitar locks)
 * @returns Promise con cantidad de formularios guardados
 */
export async function saveFormsBatch(
    forms: any[], 
    wise = false, 
    heladera = false, 
    create_refrigerator = false, 
    form_id_father = '', 
    batchSize = 50
): Promise<number> {
    if (isWeb()) {
        throw new Error('saveFormsBatch no está implementado para web')
    }

    if (!forms || forms.length === 0) {
        return 0
    }

    const db = await getDb()
    let currentBatchSize = batchSize
    let totalSaved = 0

    // Dividir en chunks y procesar con auto-ajuste de tamaño
    for (let i = 0; i < forms.length; i += currentBatchSize) {
        const chunk = forms.slice(i, i + currentBatchSize)
        let success = false
        let retryCount = 0
        const maxRetries = 5 // Aumentado de 3 a 5

        while (!success && retryCount < maxRetries) {
            try {
                await db.transaction(async (txn) => {
                    // Construir INSERT masivo con múltiples VALUES en una sola query
                    const placeholders = chunk.map(() => '(?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)').join(',')
                    
                    const allParams: any[] = []
                    for (const form of chunk) {
                        allParams.push(
                            form._id,
                            form.index_form ?? null,
                            form.repeat ?? false,
                            form.can_repeat ?? false,
                            form.icon ?? '',
                            form.check_in ?? false,
                            form.name_form ?? '',
                            form.icon_check ?? '',
                            JSON.stringify(form.type_form || {}),
                            JSON.stringify(form.contents || []),
                            JSON.stringify(form.segments || []),
                            0, // status siempre 0 para nuevos formularios
                            form.progress ?? false,
                            form.totalScore ?? 0,
                            form.show_barcode ?? false,
                            JSON.stringify(form.tags || []),
                            wise ? 1 : 0,
                            heladera ? 1 : 0,
                            create_refrigerator ? 1 : 0,
                            form_id_father || '',
                            form.start_ejecution ?? '',
                            form.end_ejecution ?? '',
                            form.link ?? '',
                            form.objective ?? null,
                            form.weigh ?? null
                        )
                    }

                    // Ejecutar una sola query con todos los valores
                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${SCHEDULES_STORE_NAMES.FORMS} (
                            _id, index_form, repeat, can_repeat, icon, check_in, 
                            name_form, icon_check, type_form, contents, segments, 
                            status, progress, totalScore, show_barcode, tags, 
                            wise, heladera, create_refrigerator, form_id_father, 
                            start_ejecution, end_ejecution, link, objective, weigh
                        ) VALUES ${placeholders};`,
                        params: allParams,
                    })

                    return { saved: chunk.length }
                })

                totalSaved += chunk.length
                success = true
                console.log(`✅ Guardados ${chunk.length} formularios (batch ${Math.floor(i / currentBatchSize) + 1}/${Math.ceil(forms.length / currentBatchSize)})`)
                
                // Pequeño delay entre batches para reducir presión en DB
                if (i + currentBatchSize < forms.length) {
                    await new Promise(resolve => setTimeout(resolve, 50))
                }
            } catch (error: any) {
                const errorMsg = error.message || ''
                
                // Si es error de lock, esperar y reintentar
                if (errorMsg.includes('database is locked')) {
                    retryCount++
                    if (retryCount < maxRetries) {
                        const waitTime = retryCount * 500 // 100ms, 200ms, 300ms
                        console.log(`⚠️ DB bloqueada, esperando ${waitTime}ms antes de reintentar (intento ${retryCount}/${maxRetries})`)
                        await new Promise(resolve => setTimeout(resolve, waitTime))
                        continue
                    } else {
                        console.error(`❌ DB bloqueada después de ${maxRetries} intentos`)
                        throw error
                    }
                }
                
                // Si falla por demasiadas variables SQL, reducir tamaño del batch
                if (errorMsg.includes('too many SQL variables') && currentBatchSize > 1) {
                    currentBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Reduciendo batch size a ${currentBatchSize} debido a límite SQL`)
                    retryCount = 0 // Reset retry count cuando cambiamos batch size
                    break // Salir del while para reintentar con batch más pequeño
                }
                
                // Cualquier otro error, propagar
                throw error
            }
        }

        // Si no tuvo éxito después de todos los reintentos, lanzar error
        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total formularios guardados: ${totalSaved}/${forms.length}`)
    return totalSaved
}

/**
 * @description Obtiene todas las campañas con sus agendas (schedules) asociadas
 * @returns Promise con array de campañas completas
 * 
 * OPTIMIZACIÓN: En lugar de hacer N queries dentro de un loop (N+1 problem),
 * ahora hace 2 queries totales:
 * 1. SELECT de todas las campañas
 * 2. SELECT de todos los schedules en una sola query con WHERE IN
 * 
 * Performance: 10-100x más rápido dependiendo de cantidad de campañas y schedules
 */
export async function getAllCampaigns(): Promise<any[]> {
    if (isWeb()) {
        throw new Error('getAllCampaigns no está implementado para web')
    }

    const db = await getDb()

    // 1. Obtener todas las campañas
    const campaignRows = await db.getAll<any>({
        sql: `SELECT * FROM ${SCHEDULES_STORE_NAMES.CAMPAINGS}`,
        params: [],
    })

    if (!campaignRows || campaignRows.length === 0) {
        return []
    }

    // 2. Construir objeto de campañas y recolectar todos los schedule IDs
    const campaigns: any[] = []
    const allScheduleIds: string[] = []
    const scheduleIdToCampaignIndex = new Map<string, number[]>() // Map schedule_id -> campaign indexes

    campaignRows.forEach((row, index) => {
        const scheduleIds = JSON.parse(row.schedules || '[]')
        
        campaigns.push({
            _id: row._id,
            name: row.name,
            code: row.code,
            image: row.image,
            date_int: row.date_init,
            date_finish: row.date_finish,
            steps: JSON.parse(row.steps || '[]'),
            total_progres: row.total_progres,
            scheduleIds: scheduleIds,
            values: JSON.parse(row.camp_values || '[]'),
            schedules: [], // Se llenará después
            schedule_free: row.schedule_free,
            date_moderation_init: row.date_moderation_init,
            date_moderation_finish: row.date_moderation_finish,
            moderation: row.moderation,
        })

        // Mapear qué schedules pertenecen a qué campaña
        scheduleIds.forEach((scheduleId: string) => {
            if (!allScheduleIds.includes(scheduleId)) {
                allScheduleIds.push(scheduleId)
            }
            
            const existingIndexes = scheduleIdToCampaignIndex.get(scheduleId) || []
            existingIndexes.push(index)
            scheduleIdToCampaignIndex.set(scheduleId, existingIndexes)
        })
    })

    // 3. Si no hay schedules, devolver las campañas vacías
    if (allScheduleIds.length === 0) {
        return campaigns
    }

    // 4. ✨ OPTIMIZACIÓN: Una sola query para obtener TODOS los schedules
    // En lugar de N queries (una por schedule), hacemos 1 query con WHERE IN
    const placeholders = allScheduleIds.map(() => '?').join(',')
    const scheduleRows = await db.getAll<any>({
        sql: `SELECT * FROM ${SCHEDULES_STORE_NAMES.SCHEDULES} WHERE _id IN (${placeholders})`,
        params: allScheduleIds,
    })

    // 5. Construir un mapa de schedules para acceso O(1)
    const scheduleMap = new Map<string, any>()
    scheduleRows.forEach((scheduleRow) => {
        const schedule = {
            _id: scheduleRow._id,
            date_finish: scheduleRow.date_finish,
            date_init: scheduleRow.date_init,
            form_finish: scheduleRow.form_finish?.length > 6 ? JSON.parse(scheduleRow.form_finish) : null,
            form_init: scheduleRow.form_init?.length > 6 ? JSON.parse(scheduleRow.form_init) : null,
            stores: [],
            progress_diary: scheduleRow.progress_diary,
            additional: JSON.parse(scheduleRow.additional || '{}'),
            distributor: JSON.parse(scheduleRow.distributor || '{}'),
            activities: JSON.parse(scheduleRow.activities || '[]'),
            others_activities: JSON.parse(scheduleRow.others_activities || '[]'),
            vacation: scheduleRow.vacation,
            activities_advances: JSON.parse(scheduleRow.activities_advances || '[]'),
            others_activities_advances: JSON.parse(scheduleRow.others_activities_advances || '[]'),
            forms_additionals: JSON.parse(scheduleRow.forms_additionals || '[]'),
            forms_incidence: scheduleRow.forms_incidence,
            reports: JSON.parse(scheduleRow.reports || '{}'),
            data_version: scheduleRow.data_version,
        }
        scheduleMap.set(scheduleRow._id, schedule)
    })

    // 6. Asignar schedules a sus campañas correspondientes
    campaigns.forEach((campaign) => {
        campaign.schedules = campaign.scheduleIds
            .map((scheduleId: string) => scheduleMap.get(scheduleId))
            .filter((schedule: any) => schedule !== undefined) // Filtrar schedules no encontrados
    })

    return campaigns
}

/**
 * @description Guarda schedules (agendas) en lotes optimizados
 * @param schedules Array de schedules a guardar
 * @param campaign_id ID de la campaña a la que pertenecen los schedules
 * @param batchSize Tamaño inicial del lote (default 100, optimizado para evitar locks)
 * @returns Promise con cantidad de schedules guardados
 * 
 * OPTIMIZACIÓN: Usa INSERT masivo con placeholders en lugar de N inserts individuales
 * Performance: 10-50x más rápido con batch inserts vs inserts individuales
 */
export async function addSchedulesBatch(
    schedules: any[], 
    campaign_id: string, 
    batchSize = 100
): Promise<number> {

    console.log(`Iniciando addSchedulesBatch con ${schedules.length} schedules para campaña ${campaign_id}`)
    console.log(`Iniciando addSchedulesBatch con ${schedules}`)

    if (isWeb()) {
        throw new Error('addSchedulesBatch no está implementado para web')
    }

    if (!schedules || schedules.length === 0) {
        return 0
    }

    const db = await getDb()
    let currentBatchSize = batchSize
    let totalSaved = 0

    // Dividir en chunks y procesar con auto-ajuste de tamaño
    for (let i = 0; i < schedules.length; i += currentBatchSize) {
        const chunk = schedules.slice(i, i + currentBatchSize)
        let success = false
        let retryCount = 0
        const maxRetries = 5

        while (!success && retryCount < maxRetries) {
            try {
                await db.transaction(async (txn) => {
                    // Construir INSERT masivo con múltiples VALUES en una sola query
                    // 19 columnas por schedule
                    const placeholders = chunk.map(() => '(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)').join(',')
                    
                    const allParams: any[] = []
                    for (const schedule of chunk) {
                        allParams.push(
                            schedule._id,
                            schedule.date_finish || '',
                            schedule.date_init || '',
                            JSON.stringify(schedule.form_finish || {}),
                            JSON.stringify(schedule.form_init || {}),
                            '[]', // stores vacíos inicialmente
                            campaign_id,
                            schedule.progress_diary ?? false,
                            JSON.stringify(schedule.additional || {}),
                            JSON.stringify(schedule.activities || []),
                            JSON.stringify(schedule.others_activities || []),
                            JSON.stringify(schedule.distributor || {}),
                            schedule.vacation ?? false,
                            JSON.stringify(schedule.activities_advances || {}),
                            JSON.stringify(schedule.others_activities_advances || {}),
                            JSON.stringify(schedule.forms_additionals || []),
                            schedule.forms_incidence ?? false,
                            JSON.stringify(schedule.reports || {}),
                            schedule.data_version ?? 0
                        )
                    }

                    // Ejecutar una sola query con todos los valores
                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${SCHEDULES_STORE_NAMES.SCHEDULES} (
                            _id,
                            date_finish,
                            date_init,
                            form_finish,
                            form_init,
                            stores,
                            campaign_id,
                            progress_diary,
                            additional,
                            activities,
                            others_activities,
                            distributor,
                            vacation,
                            activities_advances,
                            others_activities_advances,
                            forms_additionals,
                            forms_incidence,
                            reports,
                            data_version
                        ) VALUES ${placeholders};`,
                        params: allParams,
                    })

                    return { saved: chunk.length }
                })

                totalSaved += chunk.length
                success = true
                console.log(`✅ Guardados ${chunk.length} schedules (batch ${Math.floor(i / currentBatchSize) + 1}/${Math.ceil(schedules.length / currentBatchSize)})`)
            } catch (error: any) {
                const errorMsg = error.message || ''
                
                // Si es error de lock, esperar y reintentar
                if (errorMsg.includes('database is locked')) {
                    retryCount++
                    if (retryCount < maxRetries) {
                        const waitTime = retryCount * 500 // 100ms, 200ms, 300ms
                        console.log(`⚠️ DB bloqueada, esperando ${waitTime}ms antes de reintentar (intento ${retryCount}/${maxRetries})`)
                        await new Promise(resolve => setTimeout(resolve, waitTime))
                        continue
                    } else {
                        console.error(`❌ DB bloqueada después de ${maxRetries} intentos`)
                        throw error
                    }
                }
                
                // Si falla por demasiadas variables SQL, reducir tamaño del batch
                if (errorMsg.includes('too many SQL variables') && currentBatchSize > 1) {
                    currentBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Reduciendo batch size a ${currentBatchSize} debido a límite SQL`)
                    retryCount = 0 // Reset retry count cuando cambiamos batch size
                    break // Salir del while para reintentar con batch más pequeño
                }
                
                // Cualquier otro error, propagar
                throw error
            }
        }

        // Si no tuvo éxito después de todos los reintentos, lanzar error
        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total schedules guardados: ${totalSaved}/${schedules.length}`)
    return totalSaved
}

/**
 * @description Guarda stores (tiendas) en lotes optimizados con sus KPIs
 * @param stores Array de stores a guardar
 * @param batchSize Tamaño inicial del lote (default 100, optimizado para evitar locks)
 * @param step Paso del progress bar (opcional)
 * @param setProgress Callback para actualizar progreso (opcional)
 * @returns Promise con cantidad de stores guardados
 * 
 * OPTIMIZACIÓN: 
 * 1. INSERT masivo para stores
 * 2. INSERT masivo separado para KPIs (si existen)
 * 3. Evita llamadas individuales a updateStoreKPIS
 * Performance: 20-100x más rápido con batch inserts
 */
export async function addStoresBatch(
    stores: any[],
    batchSize = 500,
    step?: string,
    setProgress?: (progress: number) => void
): Promise<number> {
    if (isWeb()) {
        throw new Error('addStoresBatch no está implementado para web')
    }

    if (!stores || stores.length === 0) {
        return 0
    }

    const db = await getDb()
    let currentBatchSize = batchSize
    let totalSaved = 0
    const totalStores = stores.length

    // Helper para calcular progreso
    const updateProgress = (currentIndex: number) => {
        if (step && setProgress) {
            // PROGRESS_STEPS no está importado aquí, pero podemos calcularlo manualmente
            // o recibir start/end como parámetros. Por ahora lo simplificamos:
            const progress = Math.round((currentIndex / totalStores) * 100)
            setProgress(progress)
        }
    }

    // Dividir en chunks y procesar con auto-ajuste de tamaño
    for (let i = 0; i < stores.length; i += currentBatchSize) {
        const chunk = stores.slice(i, i + currentBatchSize)
        let success = false
        let retryCount = 0
        const maxRetries = 5 // Aumentado de 3 a 5

        while (!success && retryCount < maxRetries) {
            try {
                await db.transaction(async (txn) => {
                    // 1. INSERT masivo de stores (18 columnas)
                    const placeholders = chunk.map(() => '(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)').join(',')
                    
                    const allStoreParams: any[] = []
                    const storesWithKPIs: Array<{ store_id: string; kpis: any[] }> = []

                    for (const store of chunk) {
                        // Recolectar stores con KPIs para procesarlos después
                        if (store.kpis_indicators && store.kpis_indicators.length > 0) {
                            storesWithKPIs.push({
                                store_id: store._id,
                                kpis: store.kpis_indicators
                            })
                        }

                        allStoreParams.push(
                            store._id,
                            store.name || '',
                            store.address || '',
                            parseFloat(store.lat) || 0,
                            parseFloat(store.lng) || 0,
                            store.code || '',
                            store.cluster || '',
                            store.area || '',
                            store.region || '',
                            store.format || '',
                            store.flag || '',
                            store.maximum_distance_for_checkin || 0,
                            store.segment || '',
                            true, // existsInDB
                            store._id, // _id_mongoDB
                            store.frequency || '',
                            store.topstore || '',
                            store.potencial || ''
                        )
                    }

                    // Ejecutar INSERT masivo de stores
                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${SCHEDULES_STORE_NAMES.STORES} (
                            _id,
                            name,
                            address,
                            lat,
                            lng,
                            code,
                            cluster,
                            area,
                            region,
                            format,
                            flag,
                            maximum_distance_for_checkin,
                            segment,
                            existsInDB,
                            _id_mongoDB,
                            frequency,
                            topstore,
                            potencial
                        ) VALUES ${placeholders};`,
                        params: allStoreParams,
                    })

                    // 2. ✨ OPTIMIZACIÓN: INSERT masivo de KPIs (si hay)
                    if (storesWithKPIs.length > 0) {
                        const kpiPlaceholders = storesWithKPIs.map(() => '(?,?)').join(',')
                        const kpiParams: any[] = []

                        for (const { store_id, kpis } of storesWithKPIs) {
                            kpiParams.push(store_id, JSON.stringify(kpis))
                        }

                        await txn.run({
                            sql: `INSERT OR REPLACE INTO ${SCHEDULES_STORE_NAMES.STORES_INDICATORS} (
                                store_id, indicators
                            ) VALUES ${kpiPlaceholders};`,
                            params: kpiParams,
                        })

                        console.log(`📊 Guardados ${storesWithKPIs.length} KPIs en batch`)
                    }

                    return { saved: chunk.length }
                })

                totalSaved += chunk.length
                success = true
                
                // Actualizar progreso
                updateProgress(i + chunk.length)
                
                console.log(`✅ Guardados ${chunk.length} stores (batch ${Math.floor(i / currentBatchSize) + 1}/${Math.ceil(stores.length / currentBatchSize)})`)
            } catch (error: any) {
                const errorMsg = error.message || ''
                
                // Si es error de lock, esperar y reintentar
                if (errorMsg.includes('database is locked')) {
                    retryCount++
                    if (retryCount < maxRetries) {
                        const waitTime = retryCount * 500
                        console.log(`⚠️ DB bloqueada, esperando ${waitTime}ms antes de reintentar (intento ${retryCount}/${maxRetries})`)
                        await new Promise(resolve => setTimeout(resolve, waitTime))
                        continue
                    } else {
                        console.error(`❌ DB bloqueada después de ${maxRetries} intentos`)
                        throw error
                    }
                }
                
                // Si falla por demasiadas variables SQL, reducir tamaño del batch
                if (errorMsg.includes('too many SQL variables') && currentBatchSize > 1) {
                    currentBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Reduciendo batch size a ${currentBatchSize} debido a límite SQL`)
                    retryCount = 0
                    break
                }
                
                throw error
            }
        }

        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total stores guardados: ${totalSaved}/${stores.length}`)
    return totalSaved
}

/**
 * Guarda múltiples relaciones schedule-store (POS) en batch optimizado
 * @param posSchedules - Array de relaciones store-schedule a guardar
 * @param batchSize - Tamaño del batch (default: 100)
 * @param step - Step del progreso (opcional)
 * @param setProgress - Callback para actualizar progreso (opcional)
 * @returns Número total de registros guardados
 */
export async function addPosSchedulesBatch(
    posSchedules: any[],
    batchSize = 500,
    step?: string,
    setProgress?: (progress: number) => void
): Promise<number> {
    if (!posSchedules || posSchedules.length === 0) {
        console.log('⚠️ No hay posSchedules para guardar')
        return 0
    }

    const db = await getDb()
    let totalSaved = 0
    let currentBatchSize = batchSize
    const maxRetries = 5

    // Calcular límite de variables SQL (999 / 10 columnas = ~99 registros seguros)
    const MAX_VARIABLES = 999
    const COLUMNS_PER_SCHEDULE = 10
    const MAX_SAFE_BATCH = Math.floor(MAX_VARIABLES / COLUMNS_PER_SCHEDULE)

    if (currentBatchSize > MAX_SAFE_BATCH) {
        console.log(`⚠️ Batch size ${currentBatchSize} excede límite SQL, ajustando a ${MAX_SAFE_BATCH}`)
        currentBatchSize = MAX_SAFE_BATCH
    }

    console.log(`📦 Guardando ${posSchedules.length} pos schedules en batches de ${currentBatchSize}...`)

    for (let i = 0; i < posSchedules.length; i += currentBatchSize) {
        const chunk = posSchedules.slice(i, i + currentBatchSize)
        let retryCount = 0
        let success = false
        const maxRetriesLocal = 5 // Aumentado a 5 intentos

        while (retryCount < maxRetriesLocal && !success) {
            try {
                const saved = await db.transaction<number>(async (txn) => {
                    // Construir placeholders para batch INSERT
                    const placeholders = chunk.map(() => '(?,?,?,?,?,?,?,?,?,?)').join(',')
                    
                    // Preparar todos los parámetros en un solo array
                    const allParams: any[] = []
                    
                    for (const schedule of chunk) {
                        allParams.push(
                            schedule._id,
                            schedule.store_id,
                            schedule.schedule_id,
                            JSON.stringify(schedule.forms || []),
                            JSON.stringify(schedule.forms_relevant || []),
                            JSON.stringify(schedule.forms_featured || []),
                            schedule.campaign_status,
                            parseFloat(schedule.lat) || 0,
                            parseFloat(schedule.lng) || 0,
                            1 // existsInDB = true
                        )
                    }

                    // Single INSERT OR REPLACE con todos los registros
                    await txn.run({
                        sql: `INSERT OR REPLACE INTO schedules_pos (
                            _id,
                            store_id,
                            schedule_id,
                            forms,
                            forms_relevant,
                            forms_featured,
                            campaign_status,
                            lat,
                            lng,
                            existsInDB
                        ) VALUES ${placeholders}`,
                        params: allParams
                    })

                    return chunk.length
                })

                totalSaved += saved
                success = true

                // Actualizar progreso si se proporcionó callback
                if (step && setProgress) {
                    const currentIndex = Math.min(i + currentBatchSize, posSchedules.length)
                    const progressSteps = {
                        STEP_7: { start: 0, end: 100 }
                    } as any
                    
                    if (progressSteps[step]) {
                        const { start, end } = progressSteps[step]
                        const progress = Math.round(start + (end - start) * (currentIndex / posSchedules.length))
                        setProgress(progress)
                    }
                }

                console.log(`✅ Batch ${Math.floor(i / currentBatchSize) + 1}: ${saved} pos schedules guardados`)

            } catch (error: any) {
                retryCount++

                // Verificar si es error de variables SQL
                if (error.message?.includes('too many SQL variables') && currentBatchSize > 1) {
                    // Reducir batch size a la mitad
                    const newBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Demasiadas variables SQL, reduciendo batch de ${currentBatchSize} a ${newBatchSize}`)
                    currentBatchSize = newBatchSize
                    
                    // Reintentar este chunk con el nuevo tamaño
                    i -= currentBatchSize // Retroceder el índice
                    break
                }

                // Verificar si es error de database lock
                if (error.message?.includes('database is locked') && retryCount < maxRetries) {
                    const waitTime = retryCount * 500
                    console.log(`⏳ Database locked, reintentando en ${waitTime}ms (intento ${retryCount}/${maxRetries})...`)
                    await new Promise(resolve => setTimeout(resolve, waitTime))
                    continue
                }

                // Error no recuperable
                console.error(`❌ Error guardando pos schedules batch:`, error)
                
                if (retryCount >= maxRetries) {
                    console.error(`❌ Máximo de reintentos alcanzado para batch`)
                }
                
                throw error
            }
        }

        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total pos schedules guardados: ${totalSaved}/${posSchedules.length}`)
    return totalSaved
}

/**
 * Inserta o actualiza un advance schedule con merge inteligente de forms
 * @param schedule - Objeto con datos del advance schedule
 * @returns Promise con resultado de la operación
 */
export async function addOrUpdateAdvanceSchedule(schedule: any): Promise<{ action: 'insert' | 'update', rowsAffected: number }> {
    if (!schedule) {
        throw new Error('Schedule data is required')
    }

    const db = await getDb()

    return await db.transaction<{ action: 'insert' | 'update', rowsAffected: number }>(async (txn) => {
        // 🔥 PRIMERO: Buscar por _id (más importante que cualquier otro criterio)
        let existingById = await txn.getFirst<{ forms: string; _id: string }>({
            sql: `SELECT _id, forms FROM schedules_advances WHERE _id = ?`,
            params: [schedule._id]
        })

        // Si existe por _id, hacer UPDATE directo (no importa otros campos)
        if (existingById) {
            const formsLocal = existingById.forms ? JSON.parse(existingById.forms) : []
            const formsLlega = schedule.forms || []
            let finalForms = formsLlega

            if (formsLocal && formsLocal.length > 0) {
                // Merge: actualizar forms existentes con los nuevos datos
                finalForms = formsLocal.map((formLocal: any) => {
                    const formLlega = formsLlega.find((f: any) => f._id === formLocal._id)
                    return formLlega || formLocal
                })

                // Agregar forms nuevos que no existían localmente
                const newForms = formsLlega.filter((f: any) => 
                    !formsLocal.some((local: any) => local._id === f._id)
                )
                finalForms.push(...newForms)
            }

            // UPDATE por _id
            const result = await txn.run({
                sql: `UPDATE schedules_advances
                      SET pos_id = ?,
                          schedule_id = ?,
                          forms = ?, 
                          status = ?, 
                          form_id = ?, 
                          progress = ?,
                          score = ?, 
                          checkin_id = ?, 
                          date_modified = ?, 
                          objectives = ?,
                          distributor_id = ?,
                          date_init = ?
                      WHERE _id = ?`,
                params: [
                    schedule.pos_id || null,
                    schedule.schedule_id,
                    JSON.stringify(finalForms),
                    schedule.status,
                    schedule.form_id || '',
                    schedule.progress,
                    schedule.score,
                    schedule.checkin_id,
                    schedule.date_modified,
                    JSON.stringify(schedule.objectives || []),
                    schedule.distributor_id || '',
                    schedule.date_init,
                    schedule._id
                ]
            })

            console.log(`✅ Schedule advance actualizado por _id: ${schedule._id}`)
            return { action: 'update', rowsAffected: result.changes || 0 }
        }

        // 🔍 SEGUNDO: Si no existe por _id, buscar por otros criterios para merge
        let whereClause = ''
        let selectParams: any[] = []

        // Determinar el whereClause según el tipo de schedule
        if (schedule.form_id && schedule.form_id !== '') {
            // Caso 1: form_id (formularios de agenda matutino/vespertino)
            whereClause = `form_id = ? AND schedule_id = ? AND date(date_init) = date('now')`
            selectParams = [schedule.form_id, schedule.schedule_id]
        } else if (schedule.distributor_id && schedule.distributor_id !== '') {
            // Caso 2: distributor_id
            whereClause = `distributor_id = ? AND schedule_id = ? AND date(date_init) = date('now')`
            selectParams = [schedule.distributor_id, schedule.schedule_id]
        } else {
            // Caso 3: pos_id (más común)
            if (schedule.recover_forms) {
                whereClause = `pos_id = ? AND schedule_id = ? AND (checkin_id = ? OR checkin_id IS NULL)`
                selectParams = [schedule.pos_id, schedule.schedule_id, schedule.checkin_id]
            } else {
                whereClause = `pos_id = ? AND schedule_id = ? AND date(date_init) = date('now') AND (checkin_id = ? OR checkin_id IS NULL)`
                selectParams = [schedule.pos_id, schedule.schedule_id, schedule.checkin_id]
            }
        }

        // Buscar registro existente por otros criterios
        const existing = await txn.getFirst<{ _id: string; forms: string }>({
            sql: `SELECT _id, forms FROM schedules_advances WHERE ${whereClause} ORDER BY date_modified DESC LIMIT 1`,
            params: selectParams
        })

        let finalForms = schedule.forms || []

        // Si existe por otros criterios, hacer merge y UPDATE por su _id original
        if (existing) {
            const formsLocal = existing.forms ? JSON.parse(existing.forms) : []
            const formsLlega = schedule.forms || []

            if (formsLocal && formsLocal.length > 0) {
                // Merge: actualizar forms existentes con los nuevos datos
                finalForms = formsLocal.map((formLocal: any) => {
                    const formLlega = formsLlega.find((f: any) => f._id === formLocal._id)
                    return formLlega || formLocal
                })

                // Agregar forms nuevos que no existían localmente
                const newForms = formsLlega.filter((f: any) => 
                    !formsLocal.some((local: any) => local._id === f._id)
                )
                finalForms.push(...newForms)
            } else {
                finalForms = formsLlega
            }

            // ⚠️ IMPORTANTE: UPDATE por el _id del registro existente (no por whereClause)
            // Esto evita UNIQUE constraint errors
            const result = await txn.run({
                sql: `UPDATE schedules_advances
                      SET pos_id = ?,
                          schedule_id = ?,
                          forms = ?, 
                          status = ?, 
                          form_id = ?, 
                          progress = ?,
                          score = ?, 
                          checkin_id = ?, 
                          date_modified = ?, 
                          objectives = ?,
                          distributor_id = ?,
                          date_init = ?
                      WHERE _id = ?`,
                params: [
                    schedule.pos_id || null,
                    schedule.schedule_id,
                    JSON.stringify(finalForms),
                    schedule.status,
                    schedule.form_id || '',
                    schedule.progress,
                    schedule.score,
                    schedule.checkin_id,
                    schedule.date_modified,
                    JSON.stringify(schedule.objectives || []),
                    schedule.distributor_id || '',
                    schedule.date_init,
                    existing._id // ✅ Usar el _id del registro existente, no el nuevo
                ]
            })

            console.log(`✅ Schedule advance actualizado por criterios (mantiene _id original: ${existing._id})`)
            return { action: 'update', rowsAffected: result.changes || 0 }

        } else {
            // ✨ No existe en DB → INSERT nuevo registro
            const result = await txn.run({
                sql: `INSERT INTO schedules_advances (
                        _id, 
                        pos_id, 
                        schedule_id, 
                        forms, 
                        status, 
                        date_init, 
                        form_id, 
                        progress, 
                        score, 
                        checkin_id, 
                        date_modified, 
                        distributor_id, 
                        objectives
                      ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
                params: [
                    schedule._id,
                    schedule.pos_id || null,
                    schedule.schedule_id,
                    JSON.stringify(finalForms),
                    schedule.status,
                    schedule.date_init,
                    schedule.form_id || '',
                    schedule.progress,
                    schedule.score,
                    schedule.checkin_id,
                    schedule.date_modified,
                    schedule.distributor_id || '',
                    JSON.stringify(schedule.objectives || [])
                ]
            })

            console.log(`✅ Schedule advance insertado con _id: ${schedule._id}`)
            return { action: 'insert', rowsAffected: result.changes || 0 }
        }
    })
}

/**
 * Guarda múltiples links de assets en batch optimizado
 * Antes: forEach con N queries individuales
 * Después: Single INSERT con múltiples VALUES (100-1000x más rápido)
 * @param dataLinks - Array de URLs de assets
 * @param batchSize - Tamaño del batch (default: 500)
 * @returns Número total de links guardados
 */
export async function saveAllLinksAssetsBatch(
    dataLinks: string[],
    batchSize = 500
): Promise<number> {
    if (!dataLinks || dataLinks.length === 0) {
        console.log('⚠️ No hay links de assets para guardar')
        return 0
    }

    const db = await getDb()
    let totalSaved = 0
    const statusNoDownload = 0
    const maxRetries = 5
    let currentBatchSize = batchSize

    // Calcular límite de variables SQL (999 / 3 columnas = ~333 registros seguros)
    const MAX_VARIABLES = 999
    const COLUMNS_PER_LINK = 3
    const MAX_SAFE_BATCH = Math.floor(MAX_VARIABLES / COLUMNS_PER_LINK)

    if (currentBatchSize > MAX_SAFE_BATCH) {
        console.log(`⚠️ Batch size ${currentBatchSize} excede límite SQL, ajustando a ${MAX_SAFE_BATCH}`)
        currentBatchSize = MAX_SAFE_BATCH
    }

    console.log(`📦 Guardando ${dataLinks.length} links de assets en batches de ${currentBatchSize}...`)

    for (let i = 0; i < dataLinks.length; i += currentBatchSize) {
        const chunk = dataLinks.slice(i, i + currentBatchSize)
        let retryCount = 0
        let success = false
        const maxRetriesLocal = 5 // Aumentado a 5 intentos

        while (retryCount < maxRetriesLocal && !success) {
            try {
                const saved = await db.transaction<number>(async (txn) => {
                    // Construir placeholders para batch INSERT
                    const placeholders = chunk.map(() => '(?,?,?)').join(',')
                    
                    // Preparar todos los parámetros en un solo array
                    const allParams: any[] = []
                    
                    chunk.forEach((link, chunkIndex) => {
                        const globalIndex = i + chunkIndex
                        allParams.push(
                            globalIndex,          // indexRoute
                            statusNoDownload,     // status (0 = no descargado)
                            link                  // rute (URL)
                        )
                    })

                    // Single INSERT con todos los registros
                    await txn.run({
                        sql: `INSERT INTO assets_pf_links (
                            indexRoute,
                            status,
                            rute
                        ) VALUES ${placeholders}`,
                        params: allParams
                    })

                    return chunk.length
                })

                totalSaved += saved
                success = true

                const progress = Math.round((totalSaved / dataLinks.length) * 100)
                console.log(`✅ Batch ${Math.floor(i / currentBatchSize) + 1}: ${saved} links guardados (${progress}%)`)

            } catch (error: any) {
                retryCount++

                // Verificar si es error de variables SQL
                if (error.message?.includes('too many SQL variables') && currentBatchSize > 1) {
                    const newBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Demasiadas variables SQL, reduciendo batch de ${currentBatchSize} a ${newBatchSize}`)
                    currentBatchSize = newBatchSize
                    
                    // Reintentar este chunk con el nuevo tamaño
                    i -= currentBatchSize
                    break
                }

                // Verificar si es error de database lock
                if (error.message?.includes('database is locked') && retryCount < maxRetries) {
                    const waitTime = retryCount * 500
                    console.log(`⏳ Database locked, reintentando en ${waitTime}ms (intento ${retryCount}/${maxRetries})...`)
                    await new Promise(resolve => setTimeout(resolve, waitTime))
                    continue
                }

                // Error no recuperable
                console.error(`❌ Error guardando links de assets batch:`, error)
                
                if (retryCount >= maxRetries) {
                    console.error(`❌ Máximo de reintentos alcanzado para batch`)
                }
                
                throw error
            }
        }

        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total links de assets guardados: ${totalSaved}/${dataLinks.length}`)
    return totalSaved
}

/**
 * Guarda múltiples formularios de Perfect Store en batch optimizado
 * @param data - Array de formularios Perfect Store
 * @param batchSize - Tamaño del batch (default: 100)
 * @returns Número total de formularios guardados
 */
export async function addAllFormsPFBatch(
    data: any[],
    batchSize = 100
): Promise<number> {
    if (!data || data.length === 0) {
        console.log('⚠️ No hay formularios Perfect Store para guardar')
        return 0
    }

    const db = await getDb()
    let totalSaved = 0
    const maxRetries = 5
    let currentBatchSize = batchSize

    // Calcular límite de variables SQL (999 / 10 columnas = ~99 registros seguros)
    const MAX_VARIABLES = 999
    const COLUMNS_PER_FORM = 10
    const MAX_SAFE_BATCH = Math.floor(MAX_VARIABLES / COLUMNS_PER_FORM)

    if (currentBatchSize > MAX_SAFE_BATCH) {
        console.log(`⚠️ Batch size ${currentBatchSize} excede límite SQL, ajustando a ${MAX_SAFE_BATCH}`)
        currentBatchSize = MAX_SAFE_BATCH
    }

    console.log(`📦 Guardando ${data.length} formularios Perfect Store en batches de ${currentBatchSize}...`)

    for (let i = 0; i < data.length; i += currentBatchSize) {
        const chunk = data.slice(i, i + currentBatchSize)
        let retryCount = 0
        let success = false

        while (retryCount < maxRetries && !success) {
            try {
                const saved = await db.transaction<number>(async (txn) => {
                    // Construir placeholders para batch INSERT
                    const placeholders = chunk.map(() => '(?,?,?,?,?,?,?,?,?,?)').join(',')
                    
                    // Preparar todos los parámetros en un solo array
                    const allParams: any[] = []
                    
                    for (const item of chunk) {
                        allParams.push(
                            item._id,
                            item.status,
                            item.index,
                            item.title,
                            item.icon,
                            JSON.stringify(item.medias || []),
                            JSON.stringify(item.type || {}),
                            item.start_ejecution,
                            item.end_ejecution,
                            item.tags
                        )
                    }

                    // Single INSERT OR REPLACE con todos los registros
                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${SCHEDULES_STORE_NAMES.FORMS_PERFECT_STORE} (
                            _id,
                            status,
                            form_index,
                            title,
                            icon,
                            medias,
                            type,
                            start_ejecution,
                            end_ejecution,
                            tags
                        ) VALUES ${placeholders}`,
                        params: allParams
                    })

                    return chunk.length
                })

                totalSaved += saved
                success = true

                const progress = Math.round((totalSaved / data.length) * 100)
                console.log(`✅ Batch ${Math.floor(i / currentBatchSize) + 1}: ${saved} formularios guardados (${progress}%)`)

            } catch (error: any) {
                retryCount++

                // Verificar si es error de variables SQL
                if (error.message?.includes('too many SQL variables') && currentBatchSize > 1) {
                    const newBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Demasiadas variables SQL, reduciendo batch de ${currentBatchSize} a ${newBatchSize}`)
                    currentBatchSize = newBatchSize
                    
                    // Reintentar este chunk con el nuevo tamaño
                    i -= currentBatchSize
                    break
                }

                // Verificar si es error de database lock
                if (error.message?.includes('database is locked') && retryCount < maxRetries) {
                    const waitTime = retryCount * 500
                    console.log(`⏳ Database locked, reintentando en ${waitTime}ms (intento ${retryCount}/${maxRetries})...`)
                    await new Promise(resolve => setTimeout(resolve, waitTime))
                    continue
                }

                // Error no recuperable
                console.error(`❌ Error guardando formularios Perfect Store batch:`, error)
                
                if (retryCount >= maxRetries) {
                    console.error(`❌ Máximo de reintentos alcanzado para batch`)
                }
                
                throw error
            }
        }

        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total formularios Perfect Store guardados: ${totalSaved}/${data.length}`)
    return totalSaved
}

/**
 * Guarda relaciones entre tiendas y formularios de Perfect Store en lotes optimizados.
 * Utiliza INSERT OR REPLACE para upserts automáticos.
 *
 * @param data - Array de relaciones con estructura {pos_id, forms_ids}
 * @param batchSize - Tamaño del lote (default: 500, se auto-ajusta según límite SQL)
 * @returns Promise<number> - Cantidad total de relaciones guardadas
 *
 * @example
 * const relations = [
 *   { pos_id: 'store1', forms_ids: ['form1', 'form2'] },
 *   { pos_id: 'store2', forms_ids: ['form3'] }
 * ]
 * const saved = await addAllStoresPFRelationBatch(relations, 500)
 * console.log(`${saved} relaciones guardadas`)
 */
export async function addAllStoresPFRelationBatch(
    data: any[],
    batchSize = 500
): Promise<number> {
    const db = await getDb()
    let totalSaved = 0
    const maxRetries = 5
    let currentBatchSize = batchSize

    // Auto-ajuste para límite SQL: 999 variables / 3 columnas = 333 max
    const MAX_SAFE_BATCH = Math.floor(999 / 3)
    if (currentBatchSize > MAX_SAFE_BATCH) {
        console.log(`⚠️ Batch size ajustado de ${currentBatchSize} a ${MAX_SAFE_BATCH} para evitar límite SQL`)
        currentBatchSize = MAX_SAFE_BATCH
    }

    console.log(`🔄 Iniciando guardado de ${data.length} relaciones Perfect Store en batches de ${currentBatchSize}...`)

    for (let i = 0; i < data.length; i += currentBatchSize) {
        const chunk = data.slice(i, i + currentBatchSize)
        let retryCount = 0
        let success = false

        while (retryCount < maxRetries && !success) {
            retryCount++ // Incrementar al inicio del loop
            try {
                const saved = await db.transaction<number>(async (txn) => {
                    // Construir placeholders: (?,?,?),(?,?,?),...
                    const placeholders = chunk.map(() => '(?,?,?)').join(',')
                    const allParams: any[] = []

                    for (const item of chunk) {
                        allParams.push(
                            item.pos_id,                           // _id
                            item.pos_id,                           // pos_id (mismo que _id)
                            JSON.stringify(item.forms_ids || [])   // forms_id
                        )
                    }

                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${SCHEDULES_STORE_NAMES.STORES_PF_RELATION} (
                            _id,
                            pos_id,
                            forms_id
                        ) VALUES ${placeholders}`,
                        params: allParams
                    })

                    return chunk.length
                })

                totalSaved += saved
                success = true

                // Progress logging cada batch
                const progress = Math.round((totalSaved / data.length) * 100)
                console.log(`✅ Batch ${Math.floor(i / currentBatchSize) + 1}: ${saved} relaciones guardadas (${progress}%)`)

            } catch (error: any) {
                retryCount++

                // Error: demasiadas variables SQL
                if (error?.message?.includes('too many SQL variables') && currentBatchSize > 1) {
                    currentBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Reduciendo batch size a ${currentBatchSize} por límite SQL`)
                    i -= currentBatchSize * 2 // Retroceder para reintentar con nuevo tamaño
                    break
                }

                // Error: database locked
                if (error?.message?.includes('database is locked')) {
                    if (retryCount < maxRetries) {
                        const waitTime = retryCount * 500 // 500ms, 1000ms, 1500ms, 2000ms, 2500ms
                        console.log(`⏳ Database locked, reintentando en ${waitTime}ms... (intento ${retryCount}/${maxRetries})`)
                        await new Promise(resolve => setTimeout(resolve, waitTime))
                        continue
                    }
                }

                // Otros errores o máximo de reintentos alcanzado
                if (retryCount >= maxRetries) {
                    console.error(`❌ Error guardando batch después de ${maxRetries} intentos:`, error?.message || error)
                    throw new Error(`Error al guardar relaciones Perfect Store: ${error?.message || 'Unknown error'}`)
                }
            }
        }
    }

    console.log(`🎉 Total de relaciones Perfect Store guardadas: ${totalSaved}/${data.length}`)
    return totalSaved
}